export function GetMockCaseQueryResponseRead() {
  return [
    {
      id: 39,
      responseDate: "2022-11-30T14:28:16.0233333",
      message: "Testing a response from third party API",
      caseQueryId: 87,
      responseUserId: 438,
      caseId: 1881,
    },
  ];
}
